import { render } from "./OriginalDocumentOrderSearchWidget.vue?vue&type=template&id=5fec5fb8&ts=true"
import script from "./OriginalDocumentOrderSearchWidget.ts?vue&type=script&lang=ts&external"
export * from "./OriginalDocumentOrderSearchWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__